import React from 'react';
import { Input, Button, Form } from 'antd';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import GlobalStore from 'stores/globalStore';
import useApiService from 'hooks/base/useAPIService';

const ChangePasswordUser: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const apiService = useApiService();
  const { t } = useTranslation();
  const { currentLanguage, signOut } = GlobalStore.useContainer();

  const onUpdatePassword = (values: any) => {
    const form = { ...values };
    const fetchData = async () => {
      try {
        const response: any = await apiService.patch('/api/v1/account', form);
        if (response?.message && response?.message.indexOf('updated') > -1) {
          message.success(t('update.change_password_success'));
          signOut();
        }
      } catch (error: any) {
        if (error.message && error.message.toLowerCase().indexOf('password must contain') > -1) {
          message.error(t('update.change_password_fail'));
        }
      }
    };

    fetchData();
  };

  return (
    <div className="redeem-code">
       {currentLanguage === 'vi' ? (<Helmet>
        <title>Đổi mật khẩu đăng nhập ELSA Speak</title>
        <meta
          name="description"
          content="Đổi mật khẩu đăng nhập tài khoản ELSA Speak. ELSA Speak miễn phí, Pro trọn đời, gói ELSA Oxford Business Result, gói ELSA for Students."
        />
      </Helmet>) :
      <Helmet>
        <title>Change Password - ELSA Speak</title>
        <meta
          name="description"
          content="ELSA Speak App change password on web PC. Redeem promo code ELSA Pro, Oxford Business Result, ELSA for Students, ELSA Speak free."
        />
      </Helmet>}
      <h2>{t('profile.update_password')}</h2>
      <Form
        wrapperCol={{ span: 24 }}
        labelCol={{ span: 8 }}
        layout="horizontal"
        form={form}
        initialValues={{ layout: 'horizontal' }}
        onFinish={onUpdatePassword}
      >
        <Form.Item
          label={t('profile.current_password')}
          name="password"
          rules={[
            {
              required: true,
              message: 'Vui lòng nhập mật khẩu hiện tại'
            }
          ]}
        >
          <Input type="password" style={{ height: '50px' }} />
        </Form.Item>
        <Form.Item
          label={t('profile.new_password')}
          name="new_password"
          rules={[
            {
              required: true,
              message: 'Vui lòng nhập mật khẩu mới'
            }
          ]}
        >
          <Input style={{ height: '50px' }} type="password" />
        </Form.Item>
        <Form.Item
          label={t('profile.confirm_password')}
          name="confirm"
          dependencies={['new_password']}
          rules={[
            {
              required: true,
              message: 'Vui lòng nhập lại mật khẩu'
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('new_password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error('Nhập lại mật khẩu không khớp')
                );
              }
            })
          ]}
        >
          <Input style={{ height: '50px' }} type="password" />
        </Form.Item>

        <div className="form-footer">
          <Button
            htmlType="button"
            className="form-btn btn_cancle"
            onClick={() => navigate('/')}
          >
            {t('profile.cancel')}
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            className="form-btn btn_submit"
            // loading={isLoading}
          >
            {t('profile.save_password')}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default ChangePasswordUser;
